"use client";
import "./index.scss";
import React, { useEffect, useState, useContext, useMemo } from "react";
import { useLanguage } from "@/app/utils/LanguageContext";
import { displayText, getSearchParams, setRouting, getAssetPrefix, updateMetaTag } from "@/app/utils/Common";
import { getFormguideByRaceNo } from "@/app/utils/request/requestList";
import { pageSet } from "@/app/utils/pageSet";

const FormGuide = (props: any) => {
    const { state: lang } = useLanguage();
    const { t } = lang;
    const assetPrefix = getAssetPrefix();
    const { raceno } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search));
    const [formguideData, setFormguideData] = useState<any>(null);
    const [langData, setLangData] = useState<any>(null);

    const handleTutorialPop = (e: any) => {
        var features = 'menubar=no,height=600,width=600,scrollbars=yes';
        window.open("./tutorial", t("UserGuide"), features);
    }

    useEffect(() => {
        if (raceno) {
            getFormguideByRaceNo(raceno).then((res:any) => {
                setFormguideData(res);
                setLangData(res?.["RaceInfo" + (lang.langType == "chinese" ? "Chi" : "Eng")]);
            });
        } else {
            setRouting(undefined, { "raceno": "1" }); //default raceno = 1
        }
    }, [raceno]);

    useEffect(() => {
        setLangData(formguideData?.["RaceInfo" + (lang.langType == "chinese" ? "Chi" : "Eng")]);
    }, [lang]);

    useEffect(()=>{
        updateMetaTag(lang.langCode, pageSet.formguide);
    }, []);

    const getTrendClassName = (trend: string | number): string => {
        if (trend === undefined || trend === null || String(trend).trim() === '') {
            return '';
        }

        const value = Number(trend);

        if (value === 0) {
            return 'thumb_down';
        } else if (value === 1) {
            return 'formGuide_1up';
        } else if (value === 2) {
            return 'formGuide_2up';
        } else if (value === 3) {
            return 'formGuide_3up';
        }
        return '';
    };

    const renderHorseDataRow = (data: any, index: number) => {
        return <React.Fragment key={"horseDataGroup_" + index}>
            <tr className="comment" key={"horseRow_" + index}>
                <td className="comment-title" colSpan={3}>{data.runnerno + " " + data[lang.langType == "chinese" ? "horse_chi" : "horse_eng"]}</td>
                <td className="comment-title">{`(${data.draw})`}</td>
                <td className="comment-title">{displayText(data.body_wgt)}</td>
                <td className="comment-title">{displayText(data.wgt)}</td>
                <td className="comment-title">{lang.langType == "chinese" ? data.jockey_chi : data.jockey_eng}</td>
                <td className="comment-title">{lang.langType == "chinese" ? data.trainer_chi : data.trainer_eng}</td>
                <td className="comment-title" colSpan={2}>{t("Age") + ":" + data.age}</td>
                <td className={"comment-title formGuide_up " + getTrendClassName(data.fitnessrating)}></td>
            </tr>
            {
                data[lang.langType == "chinese" ? "comments_chi" : "comments_eng"] ?
                    <tr className="data-row">
                        <td colSpan={12} className='race-remark' dangerouslySetInnerHTML={{ __html: data[lang.langType == "chinese" ? "comments_chi" : "comments_eng"] }}></td>
                    </tr> : <></>
            }
            {data?.runnerrecords?.map(
                (record: any, n: number) => {

                    var sectionTimeCell = record?.sectional_times?.map((sec: any, i: number) => {
                        return sec.Value ? <div className={"Sectional_Times_item2"} key={"horse" + index + "_sec" + i}>
                            {sec.Key}
                            <div className="Sectional_Times_sub_item">{sec.Value.join(" ")}</div>
                        </div> :
                            <div className={"Sectional_Times_item"} key={"horse" + index + "_sec" + i}>
                                {sec.Key}
                            </div>
                    }) || [];

                    sectionTimeCell.push(<div key={"horse" + index + "_comment"} dangerouslySetInnerHTML={{ __html: record[lang.langType == "chinese" ? "comments_chi" : "comments_eng"] }}></div>)

                    return <tr className={"data-row" + (n % 2 == 0 ? " data-row-color" : "")} key={"horse" + index + "_formrec" + n}>
                        <td className="data-row-item">{record.racedate}</td>
                        <td className="data-row-item">{record.days}</td>
                        <td className="data-row-item">{displayText(lang.langType == "chinese" ? record.going_chi : record.going_eng)}</td>
                        <td className="data-row-item">{record.draw}</td>
                        <td className="data-row-item">{record.body_wgt}</td>
                        <td className="data-row-item">{record.wgt}</td>
                        <td className="data-row-item">{displayText(lang.langType == "chinese" ? record.jockey_chi : record.jockey_eng)}</td>
                        <td className="data-row-item">{record.fp + " / " + record.ts}</td>
                        <td className="data-row-item">{record.energy}</td>
                        <td className="data-row-item"><div className="Sectional_Times">{sectionTimeCell}</div></td>
                        <td className="data-row-item">{displayText(record.odds)}</td>
                    </tr>
                })}
        </React.Fragment>
    }

    return (
        <div>
            <div className="race-main">
                <div className="race-detail">
                    {
                        formguideData ?
                            <>
                                <div className="race-text">
                                    <div>{`${langData.Racecourse} ${langData.Track} - ${langData.Course}`}</div>
                                    <div>{`${langData.RaceClass} ${langData.RatingRange}`} <span style={{fontWeight: "bold"}}>{`${langData.Distance}`}</span></div>
                                    <div>{`${langData.RaceName}, ${langData.PostTime}`}</div>
                                </div>
                                <a href={`./speedguide?raceno=${raceno}`}>
                                    <img className={`has-map formguide-map raceMap-${formguideData.RaceNo}`} src={formguideData?.["RaceMap" + (lang.langType == "chinese" ? "Chi" : "Eng")]} alt="Form Guide Image"/>
                                </a>
                            </>
                            :
                            <div className="no-map"><p>{t("NoMapRemark")}</p></div>
                    }
                </div>
                <a className="guide" onClick={handleTutorialPop}><img className="tutorial-btn" src={`${assetPrefix}/speedpro/tutorial_${lang.langType}.gif`} /></a>
            </div>
            <div className="dataTables">
                {
                    formguideData?.SpeedPRO ?
                        <table className="datatable">
                            <thead>
                                <tr>
                                    <th className="datatable-en-th">{t("RaceDate")}</th>
                                    <th className="datatable-en-th">{t("Days")}</th>
                                    <th className="datatable-en-th">{t("CseDistGoing")}</th>
                                    <th className="datatable-en-th">{t("Draw")}</th>
                                    <th className="datatable-en-th">{t("BodyWeight")}</th>
                                    <th className="datatable-en-th">{t("Weight")}</th>
                                    <th className="datatable-en-th">{t("Jockey")}</th>
                                    <th className="datatable-en-th">{t("FirstPlace") + " / " + t("TotalStarter")}</th>
                                    <th className="datatable-en-th">{t("Energy")}</th>
                                    <th className="datatable-en-th">{t("SectionalTimes")}</th>
                                    <th className="datatable-en-th">{t("WinOdds")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    formguideData.SpeedPRO.map((horse: any, index: number) => renderHorseDataRow(horse, index))
                                }
                            </tbody>
                        </table>
                        : <></>
                }
            </div>
            {
                lang.langCode == "zh-hk" ?
                    <div className="remark">
                        <p>場地狀況於賽前一天中午發佈，詳情請參閱<a href="../../information/racecard" target="_blank">官方排位表</a>。</p>
                        <p>「沿途走位評語」內”W”字樣代表馬匹在每個彎位所走疊數，所有資料採用以下定義: 1W=1疊(即貼欄); 2W=2疊; 3W=3疊; 4W= 4疊, 如此類推。</p>
                        <br />
                        <p>速勢能量是由特約供應商製作，並由馬會向外界發放，供馬迷投注時作為參考。已盡一切努力務求有關參考資料盡可能準確，馬會就此並無責任。</p>
                    </div>
                    :
                    <div className="remark">
                        <p>Fitness Ratings are posted at Noon one day before race day.</p>
                        <p>Track going is posted at Noon one day before race day, please refer to <a href="../../information/racecard" target="_blank">official Race Card page</a>.</p>
                        <p>A string of numbers each followed by “W” in video comment column represents how wide the horse travelled as it went around each bend – in sequence from left to right. i.e. 1W =1 wide (rail); 2W=2 wides; 3W=3 wides; 4W=4 wides and so on.</p>
                        <br />
                        <p>SpeedPRO is produced by external vendors and is not official Jockey Club information. Every effort is made to ensure the information is as accurate as possible, but the club assumes no responsibility for it.</p>
                    </div>
            }
        </div>
    )
}

export default FormGuide;
